import { concatDataParts } from "./open-envelope";

export class MultiPartAssembler {
  private store: {
    [sender: string]: {
      [uuid: string]: MultiPart;
    };
  } = {};

  add(sender: string, part: MultiPartProps): Uint8Array | null {
    const { uuid, total, part: index, data } = part;
    let entry = this.store[sender]?.[uuid];

    if (entry == null) {
      entry = { total, uuid, dataParts: [] };
      (this.store[sender] ?? (this.store[sender] = {}))[uuid] = entry;
    }

    const expectedIndex = entry.dataParts.length;
    if (expectedIndex !== index) {
      log.err("Deleting multiPart due to unexpected index", entry);
      delete this.store[sender];
      return null;
    }

    entry.dataParts.push(new Uint8Array(data));

    if (index === total - 1) {
      const buffer = concatDataParts(entry.dataParts);
      delete this.store[sender][uuid];
      return buffer;
    }

    return null;
  }
}

export default MultiPartAssembler;
